var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',_vm._g(_vm._b({attrs:{"label":"","outlined":"","color":_vm.color}},'v-chip',_vm.$attrs,false),_vm.$listeners),[_c('span',[_vm._v(_vm._s((_vm.value || "").toUpperCase()))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }